import { EVENTBRITE_REFINEMENT_TO_CATEGORY } from '@eventbrite/categories';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { PopularTimes } from '../../../../shared/popularTimes/PopularTimes';
import { CategoryBrowseBucket } from '../../components/CategoryBrowseBucket';
import { CATEGORY_CONTENT_MAP } from '../../constants';
import { useRouteContext, useSearchContext } from '../../context';
import { useLocation } from '../../hooks/queries/location';

export const CategoryBrowsePopularTimes: React.FunctionComponent = () => {
    //Data for generating link
    const { query } = useSearchContext();
    const { data: location } = useLocation();

    const routeInfo = useRouteContext();
    const activeCategory = routeInfo.match.params.category;
    const activeCategoryKey = EVENTBRITE_REFINEMENT_TO_CATEGORY[activeCategory];
    const activeTagDisplayname = CATEGORY_CONTENT_MAP[activeCategoryKey]?.title;

    if (!location) {
        return null;
    }

    return (
        <CategoryBrowseBucket
            title={gettext('%(activeTagDisplayname)s event time options', {
                activeTagDisplayname: activeTagDisplayname,
            })}
        >
            <PopularTimes
                query={query}
                location={location}
                activeCategoryKey={activeCategoryKey}
            />
        </CategoryBrowseBucket>
    );
};
